import { takeEvery, put, call } from "redux-saga/effects";
import {
  uploadImageSuccess,
  uploadImageFailure,
  getPresignedUrlSuccess,
  getPresignedUrlFailure,
} from "../features/s3upload.slice";
import "react-toastify/dist/ReactToastify.css";
import { initializeS3Client, uploadImageToS3 } from "../../service/s3upload.service";
import { toastError } from "../../shared/util/toast.message";
import { getSignedUrl } from "@aws-sdk/s3-request-presigner";
import axios, { AxiosResponse } from "axios";
import { ENDPOINTS } from "../../service/api";
import { baseInstance } from "../../service/instance";
interface UploadImageResponse {
  success: boolean;
  message: string;
}

function* getPresignedUrl(action: any) {
  const { userId, successCallback } = action.payload;
  try {
    let res: AxiosResponse = yield call(
      baseInstance.post,
      ENDPOINTS?.PROXY,
      {
        method: "GET",
        url: process.env.REACT_APP_AUTH_BASE_URL + ENDPOINTS?.PRESIGNED_URL + `/${userId}`
      }
    );
    if (res.data.statuscode === 200) {
      const presignedUrl = res.data.data;
      yield put(getPresignedUrlSuccess(presignedUrl));
      successCallback(presignedUrl);
    }
  } catch (err: any) {
    toastError(err.message);
    yield put(getPresignedUrlFailure(err));
  }
}


function* handleUploadImage(action: any) {
  const { selectedFile, presignedUrl, successCallback } = action.payload;
  try {
    // Upload the file to S3 using the signed URL.
    // console.log("presignedUrl", presignedUrl)
    const response: AxiosResponse = yield call(
      axios.put,
      presignedUrl,
      selectedFile,
      {
        headers: {
          'Content-Type': 'image/png', // Corrected MIME type
        },
      }
    );
    if (response.status === 200) {
      yield put(uploadImageSuccess(response));
      if (successCallback) {
        successCallback();
      }
    } else {
      toastError("S3 upload failed")
      yield put(uploadImageFailure(response || "Failed to upload image"));
    }
  } catch (error: any) {
    toastError(error?.response?.data?.message)
    yield put(uploadImageFailure(error.message || "Failed to upload image"));
  }
}
function* s3uploadSaga() {
  yield takeEvery("s3UploadSlice/uploadImageRequest", handleUploadImage);
  yield takeEvery("s3UploadSlice/getPresignedUrl", getPresignedUrl);
}
export default s3uploadSaga;